import React, { useContext, useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import gsap from 'gsap';
import Flip from '../gsap/Flip.min.js';
gsap.registerPlugin(Flip);

import { useApiContext } from "../context/ApiContext.jsx";
import { AuthContext } from "../context/AuthContext.jsx";
import { useSfx } from "../hooks/useSfx.jsx";

const AvatarSelector = () => {
	const { api, isDemo } = useApiContext();
	const { sessionInfo, setSessionInfo } = useContext(AuthContext);
	const cardRef = useRef(null);
	const [avatar, setAvatar] = useState(null);
	const [avatarLoaded, setAvatarLoaded] = useState(false);
	const sfx = useSfx();

	const submitAvatar = (ev, self) => {
		ev.preventDefault();
		const avatars = document.querySelectorAll(".avatar-img");
		for (let i = 0; i < avatars.length; i++) {
			avatars[i].classList.remove("animate__bounceIn")
			avatars[i].style.animationDelay = `0ms`
			avatars[i].style.animationDuration = `600ms`
			avatars[i].classList.add("animate__bounceOut")
		}

		if (isDemo) {
			setTimeout(() => {
				setSessionInfo(prev => ({ ...(prev ?? {}), currentAvatarId: avatar }));
			}, 600)
			return;
		}

		api.post(`/api/trivia/set-session-avatar?avatarId=${avatar}`)
			.then(function (response) {
				console.log(response.data)
				setTimeout(() => {
					setSessionInfo(response.data)
				}, 600)
			})
	}

	useEffect(() => {
		if (!avatar) return;
		sfx.playSelect();
	}, [sfx, avatar]);

	useLayoutEffect(() => {
		setTimeout(() => {
			setAvatarLoaded(true)
		}, 1000)
	}, []);


	return (
		<div className="container" id="avatar-selector">
			<div className="row">
				<div className="col">
					<h1 className="mb-6 fw-semibold text-center">
						{sessionInfo.template?.mascotNormalMediaId ?
							<img className="mascotte d-block" src={`/api/trivia/media/${sessionInfo.template.mascotNormalMediaId}`} style={{ height: 165 }} />
							: "" }
						<div className="fw-bold fs-2 text-uppercase">Ok <span className="text-uppercase">{sessionInfo.nickName}</span></div>
						<small className="d-block fs-3">prima di cominciare scegli il tuo avatar!</small>
					</h1>
					<div className="d-flex flex-wrap justify-content-center avatars-container px-xl-10">
						{Array.from({ length: 24 }, (_, i) => i + 1).map((el) => {
							return <a onClick={(ev) => { ev.preventDefault(); setAvatar(el) }} href="#" className={`animate__animated animate__bounceIn avatar-img ${avatar == el ? "active" : ""}`} key={el} style={{ animationDelay: `${500 + (60 * el)}ms` }}>
								<img onMouseOver={(ev) => { if (avatarLoaded) sfx.playSwoosh({ duration: 0.5, reverse: true }) }} src={`/img/react-app/avatars/01/avatar-${el}.png`} className="user-avatar user-avatar-main mx-3 mb-3 mx-lg-5 mb-lg-5" />
							</a>
						})}
					</div>
					<div className="game-footer animate__animated animate__fadeInUp" style={{ animationDuration: "0.4s", display: avatar == null ? "none" : "" }}>
						<div className="game-footer-content d-flex justify-content-between">
							<a onClick={(ev) => submitAvatar(ev, this)} href="#" style={{ width: "fit-content" }} className={`btn btn-primary btn-lg d-flex mx-auto align-items-center ${avatar == null ? "disabled" : ""}`}>
								Inizia il gioco
							</a>
						</div>
					</div>

				</div>
			</div>
		</div>
	);
};

export default AvatarSelector;
